import React, { useState } from 'react'

import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import {  DateRange, TitleOutlined } from '@mui/icons-material'

import { Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useGlobalContext } from '../Context';
import TicketNEw from '../ViewTicketModal';
import EmptyReturn from '../EmptyReturn';
const moment=require('moment-jalaali')

const TicketListt = ({flag}) => {
    const {tickets,currentTheme}=useSelector(state=>state.p.admin)
    const [prop,setProp]=useState({})
    const {openDeleteModal,isDeleteModalOpen}=useGlobalContext();

  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        tickets?.length?tickets.map((item,index)=>{
            const {createAt}=item;
            const pbirth=moment(createAt).format('jYYYY-jMM-jDD HH:mm')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                <div  className='ThemeCard' >
        
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <SplitscreenIcon/>
                </span>
                    </div></div>
                <span> ردیف:</span>
                <span>{index+1}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <TitleOutlined/>
                </span>
                    </div></div>
                <span> عنوان :</span>
                <span>{item?.title}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>  تاریخ :</span>
                <span>{pbirth}</span>
            </div>
            <div className='btnCardDAm'>
            <div onClick={()=>{openDeleteModal();setProp(item)}} >
                مشاهده جزئیات
            </div>
            </div>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
     {currentTheme&&isDeleteModalOpen&&<TicketNEw flag={flag} data={prop}/>}

    </Container>
  )
}

export default TicketListt
